@use '@/styles/variables' as *;

.contentWrapper {
    width: 100%;
    text-align: center;
    gap: 16px;
    align-items: center;

    svg {
        fill: $accent;
        width: 29px;
        height: 29px;
    }

    span {
        font-size: 16px;
        color: $darkLighterColor;
    }
}